"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMailData = exports.sendEmail = void 0;
const sgMail = require("@sendgrid/mail");
const _ = require("lodash");
const lib_1 = require("@deliverr/commons-logs/lib");
const errors_1 = require("@deliverr/errors");
const EmailAttachment_1 = require("./EmailAttachment");
const EnvUtils_1 = require("./EnvUtils");
const DRYRUN_EMAIL = (0, EnvUtils_1.getEnvString)("DRYRUN_EMAIL", "");
const DELIVERR_EMAIL = (0, EnvUtils_1.getEnvString)("DELIVERR_EMAIL", "support@deliverr.com");
const DELIVERR_LOGS_EMAIL = (0, EnvUtils_1.getEnvString)("DELIVERR_LOGS_EMAIL", "logs@deliverr.com");
async function sendEmail(templateId, subject, recipients, substitutions, isTransactionalEmail = false, fromAddr = DELIVERR_EMAIL, ccAddr = DELIVERR_LOGS_EMAIL, asm, attachments, emailConfig) {
    const ctx = { fn: "sendEmail" };
    lib_1.log.info({ ctx, recipients, substitutions }, "started");
    setApiKeyOnce();
    await sgMail.send(createMailData(templateId, subject, DRYRUN_EMAIL === "" ? recipients : DRYRUN_EMAIL, substitutions, isTransactionalEmail, fromAddr, ccAddr, asm, attachments, emailConfig));
}
exports.sendEmail = sendEmail;
function createMailData(templateId, subject, recipients, substitutions, isTransactionalEmail = false, fromAddr = DELIVERR_EMAIL, ccAddr = DELIVERR_LOGS_EMAIL, asm, attachments, emailConfig) {
    const ctx = {
        fn: "getEmailMessage",
        recipients,
        templateId,
        subject,
        substitutions,
    };
    lib_1.log.info({ ctx }, "started");
    setApiKeyOnce();
    if (!recipients || !templateId) {
        throw new errors_1.DeliverrError("Invalid Arguments");
    }
    const baseMailData = Object.assign(Object.assign({}, emailConfig), { from: fromAddr, to: recipients, cc: ccAddr, html: "<p></p>", attachments: attachments
            ? attachments.map((attachment) => {
                return Object.assign(Object.assign({}, attachment), { disposition: EmailAttachment_1.EmailAttachmentDisposition.ATTACHMENT });
            })
            : [], templateId });
    const mailData = subject ? Object.assign(Object.assign({}, baseMailData), { subject }) : baseMailData;
    return isTransactionalEmail
        ? Object.assign(Object.assign({}, mailData), { dynamicTemplateData: substitutions, asm }) : Object.assign(Object.assign({}, mailData), { substitutionWrappers: ["%", "%"], substitutions, asm });
}
exports.createMailData = createMailData;
const setApiKey = () => {
    const sendgridApiKey = (0, EnvUtils_1.getEnvString)("SENDGRID_API_KEY", "");
    if (sendgridApiKey) {
        sgMail.setApiKey(sendgridApiKey);
    }
};
const setApiKeyOnce = _.once(setApiKey);
//# sourceMappingURL=EmailNotificationUtils.js.map